import React from "react";
import { useParams } from "react-router-dom";
import OfficialMatchDetailContent from "@/components/protocol/OfficialMatchDetailContent";

export default function OfficialMatchDetailPage() {
  const { officialId } = useParams();
  return <OfficialMatchDetailContent officialId={officialId} />;
}

